<div class="product-wizard-step">
  <ng-container *ngFor="let item of items">
    <span class="product-wizard-step__wrapper">
      <tui-badge class="product-wizard-step_status-{{ item.status }}" iconStart="@tui.check">
        {{
          isMobile
            ? ('components.productStepWizard.labels.step' | translate) + ' ' + item.stepIndex + ': ' + item.caption
            : item.caption
        }}
      </tui-badge>
    </span>
  </ng-container>

  <div class="product-wizard-step__line"></div>
</div>
